export interface AuthFeaturedProduct {
  icon: string;
  title: string;
  subtitle: string;
}

/** Produtos em destaque no painel lateral das telas de autenticação. */
export const AUTH_FEATURED_PRODUCTS: AuthFeaturedProduct[] = [
  {
    icon: '/login/icon-vida.png',
    title: 'Vida Individual',
    subtitle: 'Protegida',
  },
  {
    icon: '/login/icon-ap.png',
    title: 'Acidentes Pessoais',
    subtitle: 'Individual Premiável',
  },
];

/** Portal do corretor (i4pro) onde são cotados Vida e AP. */
export const LIFE_AP_QUOTE_URL = 'https://albanext.i4pro.com.br/corretor/';
